import { object, string } from 'zod';

export const schema = object({
  email: string().email({ message: 'Digite um email válido' }),
});
